export default {
  name: 'redesignHeaderLinks',
  namespaced: true,
  state: {
    links: [], // { id: string | number, name: string }[]
    observerIds: [], // (string | number)[]
  },
  getters: {
    getLinks: (state) => state.links,
    getObserverIds: (state) => state.observerIds,
  },
  actions: {
    /**
     * @param {*} data - { id: string | number, name: string }[]
     */
    setLinks({ commit }, data) {
      commit('SET_LINKS', data);
    },
    removeLinks({ commit }) {
      commit('SET_LINKS', []);
      commit('SET_OBSERVER_IDS', []);
    },
    setObserverId({ commit, getters }, id) {
      commit('SET_OBSERVER_IDS', [...(getters.getObserverIds || []), id]);
    },
    removeObserverId({ commit, getters }, id) {
      commit('SET_OBSERVER_IDS', getters.getObserverIds.filter((itemId) => itemId !== id));
    },
  },
  mutations: {
    SET_LINKS(state, data) {
      state.links = data;
    },
    SET_OBSERVER_IDS(state, data) {
      state.observerIds = data;
    },
  },
};
